import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getvendorsPOList,
  downloadProjectPO,
  toggleDeleteVendorInvoice,
  getProject,
} from "../../actions/project-management.action";
import { successSnackBar, errorSnackBar } from "../../actions/common.action";
import PayInvoice from "./pay-invoice";
import {
  PROJECT_MANAGEMENT,
  VENDOR_PAYMENT,
} from "../../constants/route-paths";
import { format } from "date-fns";
import VendorPaymentFilter from "./vendor-payment-filter";
import { numberFormat } from "../../util/currency-formatter";
import DownloadDialog from "../../components/download-dialog";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { withRouter } from "../../util/with-router";
import { getGlobalSettingTemplateTypes } from "./../../actions/global-setting-template.action";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "../projects/scss/task.scss";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Popover from "react-bootstrap/Popover";
import idx from "idx";
import { resolveProjectType } from "../projects/utils/resolve-project-type";
import CustomTable from "../../components/table/table";
import { GSTORVAT } from "src/util/enums";
import Modal from "../../components/modal/modal";
import UploadCostModal from "../../components/upload-cost-modal";

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPayInvoice: false,
      columns: [],
      list: [],
      submitDialog: false,
      discardDialog: false,
      deleteDialog: false,
      supplierCount: null,
      subContractorCount: null,
      vendorType: "ALL",
      invoiceData: {},
      workType: "",
      projectId: null,
      suppliers: [],
      templateOptions: [],
      subContractors: [],
      allInvoices: [],
      breadCumbText: null,
      showFilter: false,
      downloadData: {
        open: false,
        id: "",
        template: "",
      },
      projectData: null,
      deleteInvoiceData: null,
    };
  }

  // prepairing data for tree structured material table
  prepareTableData = (list) => {
    const temp = {};
    list.forEach((po) => {
      if (temp[po.vendorId]) {
        const _po = { ...po, parentId: po.vendorId, vendorId: undefined };
        _po.vendorId = Math.floor(100 + Math.random() * 10000 + 1);
        temp[po.vendorId].push(_po);
      } else {
        temp[po.vendorId] = [po];
      }
    });
    let formattedList = [];
    for (let key in temp) {
      formattedList = formattedList.concat(temp[key]);
    }
    return formattedList;
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const projectId = urlParams.get("project");
    const poId = urlParams.get("poId") || urlParams.get("woId");

    let workType = "project";
    let breadCumbText = null;
    if (projectId) {
      workType = "project";
      breadCumbText = "Project";
    }

    this.setState({ workType, projectId, poId, breadCumbText }, () =>
      this.fetchList(),
    );

    if (!this.state.projectData && projectId) {
      this.props.getProject(projectId).then((projectData) => {
        this.setState({
          projectData: projectData,
        });
      });
    }

    if (this.props.location?.state?.openUploadCostModal) {
      this.setState({ uploadCostOpen: true });
    }
  }

  getAssetList = async (selectedCategory = "ALL") => {
    return null;
  };

  handleMenu = (rowData) => {
    this.setState({
      invoiceId: rowData.invoiceId,
      invoiceData: {
        poId: rowData.poId,
        poNumber: rowData.poNumber,
        isSubContractor: rowData.vendorType === "sub-contractor",
        invoiceId: rowData.invoiceId,
        projectId: rowData.projectId || this.state.projectId,
        vendorId: rowData.vendorId,
      },
      deleteInvoiceData: rowData,
    });
  };

  handlePayInvoiceModal = (status, allProjects = false) => {
    if (!status) this.fetchList();
    this.setState((prevState) => ({
      showPayInvoice: status,
      invoiceData: { ...(allProjects ? {} : { ...prevState.invoiceData }) },
    }));
  };

  fetchList = async ({
    pageNo,
    pageSize,
    vendorType,
    startDate,
    endDate,
  } = {}) => {
    const params = { pageNo, pageSize, vendorType, startDate, endDate };
    let { projectId, poId } = this.state;
    if (projectId) params.projectId = projectId;
    if (poId) params.poId = poId;

    this.setState({ vendorType: vendorType || "ALL" });

    let { list = [], vendorTypesCount = 0 } =
      await this.props.getvendorsPOList(params);

    const suppliers =
      (Array.isArray(list) &&
        list.filter(({ vendorType }) => vendorType === "Supplier")) ||
      [];
    const subContractors =
      (Array.isArray(list) &&
        list.filter(({ vendorType }) => vendorType === "sub-contractor")) ||
      [];
    const allInvoices = (Array.isArray(list) && list) || [];
    const supplierCount = vendorTypesCount.suppliersCount || 0;
    const subContractorCount = vendorTypesCount.subContractorsCount || 0;
    const columns = [
      {
        title: "Vendor Name",
        field: "vendorName",
        render: (rowData) => rowData.vendorName,
      },
      {
        title: "Vendor Type",
        field: "vendorType",
        dataCy: "vendor-type",
        // lookup: { "sub-contractor": "Sub-Contractor", Supplier: "Supplier" },
        render: (rowData) =>
          rowData.vendorType == "sub-contractor"
            ? "Sub-Contractor"
            : rowData.vendorType,
      },
      {
        title: "Invoice No",
        field: "invoiceNo",
        dataCy: "invoice-no",
        render: (rowData) => <span>{rowData.invoiceNo}</span>,
      },
      {
        title: "PO/WO Number",
        field: "poNumber",
        dataCy: "po-number",
        /* fId is the PO number with project prefix and Suffix if null then default to po Number*/
        render: (rowData) => rowData.fId || rowData.poNumber,
      },
      {
        title: "Project/Job",
        field: "projectName",
        render: (rowData) => rowData.projectName,
        dataCy: "project-job",
      },
      {
        title: "Invoice Date",
        field: "invoiceDate",
        type: "date",
        dataCy: "invoice-date",
        render: (rowData) =>
          (rowData.invoiceDate &&
            format(new Date(rowData.invoiceDate), "dd/MM/yyyy")) ||
          "",
      },
      {
        title: "Due Date",
        field: "dueDate",
        type: "date",
        dataCy: "due-date",
        render: (rowData) =>
          rowData.dueDate
            ? format(new Date(rowData.dueDate), "dd/MM/yyyy")
            : "",
      },
      {
        title: (
          <div>
            <span className="text-nowrap">Amount Due</span>
            <br />
            <span className="text-nowrap">(Ex. GST)</span>
          </div>
        ),
        field: "amountPaid",
        dataCy: "amount-due",
        render: (rowData) => `${numberFormat(rowData.subTotal)}`,
        class: "text-right",
      },
      /*{
        title: "Retained Amount",
        field: "retainedAmount",
        dataCy: 'retained-amount',
        render: (rowData) => `${numberFormat(rowData.retainedAmount)}`,
        class: 'text-right',
      },*/
      {
        title: "Progress Claim",
        field: "progressClaimNumber",
        dataCy: "progress-claim",
        render: (rowData) =>
          rowData.vendorType === "sub-contractor"
            ? rowData.progressClaimNumber || "-"
            : "-",
      },
      {
        title: "Received By",
        field: "userName",
        dataCy: "received-by",
        render: (rowData) => rowData.userName,
      },
    ];
    list.forEach((item, index) => {
      item["id"] = index;
      return item;
    });
    this.setState({
      supplierCount,
      subContractorCount,
      columns,
      list,
      suppliers,
      subContractors,
      allInvoices,
    });
  };

  changeWorkType = (workType) => {
    this.setState({ workType }, () => {
      if (this.props[`${workType}Module`] === false) {
        this.props.warningSnackBar(
          `This user does not have access for ${workType === "service" ? "Services" : "any Projects"}`,
        );
        return false;
      }
      this.fetchList({});
    });
  };

  viewPO = () => {
    const { workType, invoiceId, projectId, poId } = this.state;
    this.props.history(
      `/${VENDOR_PAYMENT}/view/${invoiceId}${`?type=${workType}`}${projectId ? `&id=${projectId}` : ""}${poId ? `&poId=${poId}` : ""}`,
    );
  };

  deletePO = () => {
    this.setState({ deleteDialog: true });
  };

  confirmDelete = () => {
    const { invoiceId } = this.state;

    this.props
      .toggleDeleteVendorInvoice(invoiceId)
      .then((response) => {
        // Close the modal
        this.setState({ deleteDialog: false });

        // Add delay to show success snackbar before full page reload
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      })
      .catch((error) => {
        // Show error message (API action handles this, but adding explicit error handling)
        this.props.errorSnackBar("Error deleting invoice");

        // Still close the modal on error
        this.setState({ deleteDialog: false });
      });
  };

  cancelDelete = () => {
    this.setState({ deleteDialog: false });
  };

  showFilterHandler = () => {
    this.setState((prevState) => ({
      showFilter: !prevState.showFilter,
    }));
  };

  dateChangeFilter = (startDate, endDate) => {
    this.fetchList({ startDate, endDate });
  };

  changeFilter = (vendorType) => {
    const { suppliers, subContractors, allInvoices } = this.state;
    let list = [];

    if (vendorType === "Supplier") {
      list = suppliers;
    } else if (vendorType === "sub-contractor") {
      list = subContractors;
    } else if (vendorType === "ALL") {
      list = allInvoices;
    }

    list = this.prepareTableData(list);

    this.setState({ vendorType, list });
  };
  gettemplate = async (type) => {
    let newdata = [];
    let projectId = this.state.projectId;
    const templateData = await this.props.getGlobalSettingTemplateTypes(
      type,
      projectId,
    );
    if (Array.isArray(templateData)) {
      templateData.forEach((item) => {
        newdata.push({
          value: item.id,
          key: item.name,
        });
      });
    }
    this.setState({ templateOptions: newdata });
  };
  handleDownloadDialog = (id = "", templateType = "subcontractor_payment_schedule", overrideData = null) => {
    const currentId = id && (typeof id === 'string' || typeof id === 'number') ? id : this.state.invoiceId;
    this.setState((prevState) => {
      const isOpening = !prevState.downloadData.open;
      return {
        downloadData: {
          ...prevState.downloadData,
          open: isOpening,
          id: currentId || "",
          overrideData
        }
      };
    }, () => {
      if (this.state.downloadData.open) {
        this.gettemplate(templateType);
      }
    });
  };

  downloadFile = async (fileFormat = "pdf", templatevalue) => {
    try {
      const { downloadData = {} } = this.state;

      if (fileFormat === "pdf" || fileFormat === "ALL") {
        await this.props
          .downloadProjectPO(
            downloadData.id,
            fileFormat,
            templatevalue,
            undefined,
            downloadData.overrideData,
          )
          .catch((e) => console.error(e));
      }
      if (fileFormat === "docx" || fileFormat === "ALL") {
        await this.props
          .downloadProjectPO(
            downloadData.id,
            fileFormat,
            templatevalue,
            undefined,
            downloadData.overrideData,
          )
          .catch((e) => console.error(e));
      }
      this.handleDownloadDialog();
    } catch (e) {
      console.error(e);
    }
  };

  viewInvoice(rowData) {
    this.setState(
      {
        invoiceId: rowData.invoiceId,
        invoiceData: {
          poNumber: rowData.poNumber,
          isSubContractor: rowData.vendorType === "sub-contractor",
        },
      },
      () => {
        this.viewPO();
      },
    );
  }

  ViewProjectList = () => {
    let type = resolveProjectType(
      idx(this.state, (_) => _.projectData.projectType),
      this.props.projectState,
    );
    this.props.history(`/${PROJECT_MANAGEMENT}?project-type=${type}`);
  };

  ViewProject = () => {
    let { projectId } = this.state;
    this.props.history(`/${PROJECT_MANAGEMENT}/view/${projectId}`);
  };

  render() {
    const {
      columns,
      supplierCount,
      subContractorCount,
      showPayInvoice,
      invoiceData,
      workType,
      projectId,
      templateOptions,
      breadCumbText,
      showFilter,
      downloadData,
      suppliers,
      subContractors,
      allInvoices,
      projectData,
    } = this.state;
    const { projectModule, writePermission } = this.props;


    return (
      <>
        <DownloadDialog
          {...downloadData}
          downloadFile={this.downloadFile}
          handleDownloadDialog={this.handleDownloadDialog}
          templateOptions={templateOptions}
          downloadModuleName="Vendor Payment"
        />
        {showPayInvoice && (
          <PayInvoice
            {...invoiceData}
            workType={workType}
            handleDownloadDialog={this.handleDownloadDialog}
            handleClose={() => this.handlePayInvoiceModal(false)}
          />
        )}
        {
          <VendorPaymentFilter
            changeFilter={this.dateChangeFilter}
            changeWorkType={this.changeWorkType}
            workType={workType}
            dialogClose={this.showFilterHandler}
            open={showFilter}
          />
        }

        {projectModule === false ? (
          <p>
            You do not currently have access to any Projects. Please contact
            your Administrator if this is required.
          </p>
        ) : (
          <>
            <div
              className="purchase-order-block"
              data-cy="view-invoice-container"
            >
              <div className="row">
                <div className="w-auto">
                  <h2 className="content-heading text-uppercase">
                    Vendor Invoices
                  </h2>
                  <div className="col-12 breadcrumb-block p-0">
                    <Breadcrumb>
                      {
                        breadCumbText ? (
                          <>
                            <Breadcrumb.Item
                              onClick={this.ViewProjectList}
                              data-cy="projects-breadcrumb"
                            >
                              PROJECTS
                            </Breadcrumb.Item>
                            <Breadcrumb.Item
                              onClick={this.ViewProject}
                              data-cy="project-breadcrumb"
                            >
                              {idx(this.state, (_) => _.projectData.name)}
                            </Breadcrumb.Item>
                            <Breadcrumb.Item
                              active
                              data-cy="vendor-invoices-breadcrumb"
                            >
                              Vendor Invoices
                            </Breadcrumb.Item>
                          </>
                        ) : (
                          ""
                        )
                        // <Breadcrumb.Item active>Vendor Invoices</Breadcrumb.Item>
                      }
                    </Breadcrumb>
                  </div>
                </div>
                {projectId ? (
                  <div className="w-auto ms-auto mt-auto">
                    {writePermission &&
                      projectData?.status !== "TENDER_PENDING" &&
                      projectData?.status !== "TENDER_SUBMITTED" &&
                      projectData?.status !== "COSTED" &&
                      projectData?.status !== "LOI" && (
                        <button
                          className="secondarybtn secondarybtn-outline btn-ch ms-auto btn btn-primary"
                          onClick={() => this.setState({ uploadCostOpen: true })}
                          data-cy="upload-cost-btn"
                        >
                          Upload Cost
                        </button>
                      )}
                  </div>
                ) : (
                  <div className="w-auto ms-auto mt-auto d-flex align-items-center gap-2">
                    {writePermission && (
                      <>
                        <button
                          className="secondarybtn secondarybtn-outline btn-ch btn btn-primary"
                          onClick={() => this.setState({ uploadCostOpen: true })}
                          data-cy="upload-cost-btn"
                          style={{ marginRight: "8px" }}
                        >
                          Upload Cost
                        </button>
                        <button
                          className="secondarybtn secondarybtn-outline btn-ch btn btn-primary"
                          onClick={() => this.handlePayInvoiceModal(true, true)}
                          data-cy="receive-invoice"
                        >
                          Receive Invoice
                        </button>
                      </>
                    )}
                    <button
                      onClick={this.showFilterHandler}
                      aria-label="filter"
                      className="btn"
                      data-cy="filter-button"
                    >
                      <FilterAltIcon />
                    </button>
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-12">
                  <Tabs
                    activeKey={this.state.vendorType || "ALL"}
                    onSelect={(k) => this.setState({ vendorType: k })}
                    id="uncontrolled-tab-example"
                    className="mb-3"
                    tabClassName="vendor-invoices-tab"
                  >
                    <Tab
                      eventKey="ALL"
                      title={`All (${parseInt(supplierCount) + parseInt(subContractorCount) || 0})`}
                    >
                      <CustomTable
                        columns={columns}
                        data={allInvoices}
                        isAction={true}
                        handleMenu={(data) => this.handleMenu(data)}
                        dataCy="all-invoices-table"
                        menu={(data) => (
                          <Popover id="popover-basic">
                            <Popover.Body>
                              <ul className="action-block-list">

                                <li
                                  onClick={() => this.viewPO()}
                                  data-cy="view-invoice"
                                >
                                  View Invoice
                                </li>
                                {data.vendorType === "sub-contractor" && (
                                  <li
                                    onClick={() =>
                                      this.handleDownloadDialog(data.invoiceId)
                                    }
                                    data-cy="download-payment-schedule"
                                  >
                                    Download Payment Schedule
                                  </li>
                                )}
                                <li
                                  onClick={() => this.deletePO()}
                                  data-cy="view-invoice"
                                  className="text-danger"
                                >
                                  Delete
                                </li>
                              </ul>
                            </Popover.Body>
                          </Popover>
                        )}
                        fileName="Vendor Invoices List"
                      />
                    </Tab>

                    <Tab
                      eventKey="Supplier"
                      title={`Suppliers (${supplierCount})`}
                    >
                      <CustomTable
                        columns={columns.filter(
                          (column) =>
                            column.field !== "retainedAmount" &&
                            column.field !== "progressClaimNumber",
                        )}
                        data={suppliers}
                        isAction={true}
                        handleMenu={(data) => this.handleMenu(data)}
                        dataCy="suppliers-table"
                        menu={(data) => (
                          <Popover id="popover-basic">
                            <Popover.Body>
                              <ul className="action-block-list">

                                <li
                                  onClick={() => this.viewPO()}
                                  data-cy="view-invoice"
                                >
                                  View Invoice
                                </li>
                                {data.vendorType === "sub-contractor" && (
                                  <li
                                    onClick={() =>
                                      this.handleDownloadDialog(data.invoiceId)
                                    }
                                    data-cy="download-payment-schedule"
                                  >
                                    Download Payment Schedule
                                  </li>
                                )}
                                <li
                                  onClick={() => this.deletePO()}
                                  data-cy="view-invoice"
                                  className="text-danger"
                                >
                                  Delete
                                </li>
                              </ul>
                            </Popover.Body>
                          </Popover>
                        )}
                        fileName="Supplier Invoices List"
                      />
                    </Tab>

                    <Tab
                      eventKey="sub-contractor"
                      title={`Contractors (${subContractorCount})`}
                    >
                      <CustomTable
                        columns={columns}
                        data={subContractors}
                        isAction={true}
                        handleMenu={(data) => this.handleMenu(data)}
                        dataCy="contractors-table"
                        menu={(data) => (
                          <Popover id="popover-basic">
                            <Popover.Body>
                              <ul className="action-block-list">

                                <li
                                  onClick={() => this.viewPO()}
                                  data-cy="view-invoice"
                                >
                                  View Invoice
                                </li>
                                {data.vendorType === "sub-contractor" && (
                                  <li
                                    onClick={() =>
                                      this.handleDownloadDialog(data.invoiceId)
                                    }
                                    data-cy="download-payment-schedule"
                                  >
                                    Download Payment Schedule
                                  </li>
                                )}
                                <li
                                  onClick={() => this.deletePO()}
                                  data-cy="view-invoice"
                                  className="text-danger"
                                >
                                  Delete
                                </li>
                              </ul>
                            </Popover.Body>
                          </Popover>
                        )}
                        fileName="Contractor Invoices List"
                      />
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </>
        )}

        {/* Delete Confirmation Modal */}
        <Modal
          open={this.state.deleteDialog}
          onClose={this.cancelDelete}
          modalHeading="Confirm Delete"
          maxWidth="sm"
          modalContent={
            <div className="p-4 text-center">
              <p className="mb-2">
                Are you sure you want to delete this invoice?
              </p>
              {this.state.deleteInvoiceData && (
                <div className="bg-light border rounded p-3 mb-3 text-start">
                  <div className="d-flex justify-content-between gap-3 py-1 border-bottom">
                    <span>Invoice No</span>
                    <strong>{this.state.deleteInvoiceData.invoiceNo || "-"}</strong>
                  </div>
                  <div className="d-flex justify-content-between gap-3 py-1 border-bottom">
                    <span>Vendor</span>
                    <strong>{this.state.deleteInvoiceData.vendorName || "-"}</strong>
                  </div>
                  <div className="d-flex justify-content-between gap-3 py-1 border-bottom">
                    <span>{this.state.deleteInvoiceData.vendorType === "sub-contractor" ? "WO Number" : "PO Number"}</span>
                    <strong>{this.state.deleteInvoiceData.fId || this.state.deleteInvoiceData.poNumber || "-"}</strong>
                  </div>
                  <div className="d-flex justify-content-between gap-3 py-1 border-bottom">
                    <span>Project/Job</span>
                    <strong>{this.state.deleteInvoiceData.projectName || "-"}</strong>
                  </div>
                  <div className="d-flex justify-content-between gap-3 py-1">
                    <span>Amount</span>
                    <strong>{numberFormat(this.state.deleteInvoiceData.subTotal || this.state.deleteInvoiceData.amountPaid || 0)}</strong>
                  </div>
                </div>
              )}
              <p className="text-danger fw-bold mb-0">
                <i className="fas fa-exclamation-triangle me-2"></i>
                This action cannot be undone.
              </p>
            </div>
          }
          cancel="Cancel"
          save="Delete"
          onClick={this.cancelDelete}
          onEdit={this.confirmDelete}
        />

        {this.state.uploadCostOpen && (
          <UploadCostModal
            open={this.state.uploadCostOpen}
            onClose={() => this.setState({ uploadCostOpen: false })}
            projectId={projectId}
            defaultType={
              this.state.vendorType === "Supplier"
                ? "Material"
                : this.state.vendorType === "sub-contractor"
                  ? "Contractor"
                  : ""
            }
            onSaveSuccess={() => this.fetchList()}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.userData,
  projectModule: state.project.projectModule,
  projectState: state.project,
  projectDetail: state.projectDetail,
});

const mapDispatchToProps = (dispatch) => ({
  getvendorsPOList: bindActionCreators(getvendorsPOList, dispatch),
  getGlobalSettingTemplateTypes: bindActionCreators(
    getGlobalSettingTemplateTypes,
    dispatch,
  ),
  downloadProjectPO: bindActionCreators(downloadProjectPO, dispatch),
  toggleDeleteVendorInvoice: bindActionCreators(
    toggleDeleteVendorInvoice,
    dispatch,
  ),
  successSnackBar: bindActionCreators(successSnackBar, dispatch),
  errorSnackBar: bindActionCreators(errorSnackBar, dispatch),
  getProject: bindActionCreators(getProject, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(List));
